let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aLs7v")).then(() => parcelRequire('j88xs'));